import React from 'react';
import './BlurLoader.css';

function BlurLoader({ active, text, showLogo, logo, mode }) {
  if (mode !== 'blur') return null;

  return (
    <div className={`blur-loader ${active ? 'active' : 'fade-out'}`}>
      <div className="blur-backdrop" />
      <div className="blur-content">
        {showLogo && logo && (
          <div className="blur-logo">
            <img src={logo} alt="Logo" className="blur-logo-img" />
          </div>
        )}
        <div className="blur-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        {text && (
          <p className="blur-text">{text}</p>
        )}
      </div>
    </div>
  );
}

export default BlurLoader;